import isEmailValidator from 'validator/lib/isEmail';
import * as yup from 'yup';

import {
  FORM_ERROR_MESSAGES,
  MAX_EMAIL_LENGTH,
  MAX_FIRST_NAME_LENGTH,
  MAX_LAST_NAME_LENGTH,
  MIN_LENGTH
} from '@hero/constants';

const regex = {
  isNumber: new RegExp(/\d/),
  isSpecialChar: new RegExp(/[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/),
  isUpperCase: new RegExp(/[A-Z]/),
  isLowerCase: new RegExp(/[a-z]/),
  isLetter: new RegExp(/[a-zA-Z]/)
};

const contactInfoSchema = yup.object().shape({
  firstName: yup.string().min(MIN_LENGTH).max(MAX_FIRST_NAME_LENGTH).required(),
  lastName: yup.string().min(MIN_LENGTH).max(MAX_LAST_NAME_LENGTH).required(),
  phone: yup.string().min(11, 'Phone is required').required('Required'),
  password: yup.mixed().test('is-valid-password', 'Invalid password', password => {
    let validCount = 0;
    regex.isSpecialChar.test(password) && validCount++;
    regex.isNumber.test(password) && validCount++;
    regex.isLowerCase.test(password) && validCount++;
    regex.isUpperCase.test(password) && validCount++;
    return validCount > 2 && password.length >= 8;
  }),
  confirmPassword: yup
    .string()
    .required()
    .oneOf([yup.ref('password')], 'Passwords must match')
});

const emailSchema = yup
  .string()
  .email('invalidEmail')
  .max(MAX_EMAIL_LENGTH, FORM_ERROR_MESSAGES.max50Char)
  .required(FORM_ERROR_MESSAGES.emailRequired)
  .test(
    'is-valid',
    () => 'invalidEmail',
    value => (value ? isEmailValidator(value) : new yup.ValidationError('invalidEmail'))
  );

const inviteInfoSchema = yup.object().shape({
  firstName: yup.string().min(MIN_LENGTH).max(MAX_FIRST_NAME_LENGTH).required(),
  lastName: yup.string().min(MIN_LENGTH).max(MAX_LAST_NAME_LENGTH).required(),
  email: emailSchema,
  password: yup.mixed().test('is-valid-password', 'Invalid password', password => {
    let validCount = 0;
    regex.isSpecialChar.test(password) && validCount++;
    regex.isNumber.test(password) && validCount++;
    regex.isLowerCase.test(password) && validCount++;
    regex.isUpperCase.test(password) && validCount++;
    return validCount > 2 && password.length >= 8;
  }),
  confirmPassword: yup
    .string()
    .required()
    .oneOf([yup.ref('password')], 'Passwords must match')
});

export { contactInfoSchema, inviteInfoSchema, regex };
